import React, { useEffect, useState } from 'react';
import { Link } from 'gatsby';
import { getImage, IGatsbyImageData, GatsbyImage } from 'gatsby-plugin-image';
import styled from 'styled-components';

import PostContent from '../components/post/PostContent';
import Publicidad from '../components/utilities/Publicidad';
import SidebarNews from '../components/post/SidebarNews';
import SidebarPodcasts from '../components/post/SidebarPodcasts';
import { getMainCategorySlug } from '../utils/utilities';
import { Post, PublicidadType } from '../types/types';
import { setCarnavalHours, setTitulosPersonalizadosReproductor } from '../slices/AppSlice';
import { useAppDispatch } from '../types/hooks';

const StyledPostContainer = styled.div`
  @media (min-width: 576px) {
    display: grid;
    grid-template-columns: 700px auto;
  }
  .post-desktop-container {
    .post-header {
      border-bottom: 1px solid var(--border-gray);
      margin: 0.5rem 1rem;
      font-family: 'TradeGothicN2';
      text-transform: uppercase;
      font-size: 1rem;
      padding-bottom: 0.5rem;
      @media (min-width: 576px) {
        margin: 0.5rem 0;
      }
      a {
        color: black;
        text-decoration: none;
      }
    }
    .tag {
      color: var(--rojo-principal);
      margin: 1rem 0.75rem;
      font-family: 'TradeGothicN2';
      text-transform: uppercase;
      font-size: 1rem;
      @media (min-width: 576px) {
        margin: 1rem 0;
      }
    }
    h1 {
      margin: 1rem;
      font-family: 'TradeGothic Gold20';
      font-size: 1.5rem;
      @media (min-width: 576px) {
        margin: 1rem 0;
        font-size: 36px;
      }
    }
    .feature-image-container {
      position: relative;
      .gatsby-image-wrapper {
        border-top: 4px solid black;
      }
      .feature-image {
        border-top: 4px solid black;
        width: 100%;
        aspect-ratio: 4/3;
        object-fit: cover;
      }
      .white-logo-container {
        background-color: black;
        position: absolute;
        left: 0.975rem;
        top: 0;
        padding: 0.5rem 0.5rem 0.3rem;
        border-bottom-right-radius: 0.5rem;
        border-bottom-left-radius: 0.5rem;
      }
    }
  }
  .publicidad-and-side-bar {
    display: flex;
    flex-direction: column;
    border-top: 1px solid var(--border-gray);
    margin: 0 1rem;
    padding-top: 1rem;
    @media (min-width: 576px) {
      border-top: none;
      padding-top: 0;
    }
    .side-bar {
      order: 1;
      .divider {
        border-bottom: 1px solid var(--border-gray);
      }
      @media (min-width: 576px) {
        display: block;
        margin: 0 2rem;
        order: 1;
      }
    }
  }
`;

type PostTemplateProps = {
  post: Post;
  publicidadPosts: {
    mobile: PublicidadType;
    desktop: PublicidadType;
  };
  newsPosts: Post[];
  podcastPosts: Post[];
  gatsbyConfig: {
    basketConfig: string;
    carnavalConfig: string;
    playerCustomTitles: string;
  };
};

const PostTemplate = ({
  post,
  publicidadPosts,
  newsPosts,
  podcastPosts,
  gatsbyConfig,
}: PostTemplateProps) => {
  const [postImage, setPostImage] = useState<IGatsbyImageData>();
  const [mainCategorySlug, setMainCategorySlug] = useState<string>('');
  const dispatch = useAppDispatch();

  useEffect(() => {
    if (post.featuredImage && post.featuredImage.node.localFile) {
      setPostImage(getImage(post.featuredImage.node.localFile));
    }
    setMainCategorySlug(getMainCategorySlug(post.categories.nodes));

    if (!gatsbyConfig) return;
    if (gatsbyConfig.playerCustomTitles)
      dispatch(setTitulosPersonalizadosReproductor(gatsbyConfig.playerCustomTitles));
    if (gatsbyConfig.carnavalConfig) dispatch(setCarnavalHours(gatsbyConfig.carnavalConfig));
  }, []);

  return (
    <>
      {/* Publicidad principal NOTICIAS Desktop */}
      {/* {publicidadPosts.desktop && publicidadPosts.desktop.featuredImage && (
        <PublicidadPrincipalNoticiasDesktop
          alt={publicidadPosts.desktop.featuredImage.node.altText}
          image={publicidadPosts.desktop.featuredImage.node.localFile}
          link={publicidadPosts.desktop.config.link}
        />
      )}
      {publicidadPosts.mobile && publicidadPosts.mobile.featuredImage && (
        <PublicidadPrincipalNoticiasDesktop
          alt={publicidadPosts.mobile.featuredImage.node.altText}
          image={publicidadPosts.mobile.featuredImage.node.localFile}
          link={publicidadPosts.mobile.config.link}
        />
      )} */}
      <StyledPostContainer>
        <div className="post-desktop-container">
          <div className="post-header">
            <Link to="/">˂ Volver a Portada</Link>
          </div>
          {post.tags && post.tags.nodes && post.tags.nodes.length > 0 && (
            <p className="tag">{post.tags.nodes[0].name}</p>
          )}
          <h1>{post.title}</h1>
          <div className="feature-image-container">
            {postImage && post.featuredImage && (
              <GatsbyImage alt={post.featuredImage.node.altText} image={postImage} />
            )}
            {!postImage &&
              post.featuredImage &&
              post.featuredImage.node &&
              post.featuredImage.node.sourceUrl && (
                <img
                  alt={post.featuredImage.node.altText}
                  className="feature-image"
                  src={post.featuredImage.node.sourceUrl}
                />
              )}
          </div>
          <PostContent mainCategorySlug={mainCategorySlug} post={post} />
        </div>
        <div className="publicidad-and-side-bar">
          <div className="side-bar">
            <SidebarNews newsPosts={newsPosts} postId={post.id} />
            <div className="divider" />
            <SidebarPodcasts
              mainCategorySlug={mainCategorySlug}
              podcastPosts={podcastPosts}
              postId={post.id}
            />
          </div>
        </div>
      </StyledPostContainer>
    </>
  );
};

export default PostTemplate;
